import { render, staticRenderFns } from "./base-data.vue?vue&type=template&id=cc475c9e&scoped=true"
import script from "./base-data.vue?vue&type=script&lang=js"
export * from "./base-data.vue?vue&type=script&lang=js"
import style0 from "./base-data.vue?vue&type=style&index=0&id=cc475c9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc475c9e",
  null
  
)

export default component.exports